import React, { Component } from 'react';

class SuperAdminFooterComponent extends Component {
    constructor(props) {

        super(props);
    }
    render() {
        var currentYear = new Date().getFullYear()
        return (
            <div className="footer">
                <p>{currentYear} <a>All Rights Reserved. </a>
                </p>
            </div>
        );
    }
}

export default SuperAdminFooterComponent;